import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import {
    Grid,
    Box,
} from '@material-ui/core';

import useAddOnsDialog from './dialogs/addOnsDialog/useAddOnsDialog';
import useUpgradePlanDialog from './dialogs/upgradePlanDialog/useUpgradePlanDialog';
import { useStyles } from './styles';
import useEcalPlanState from './useEcalPlanState';
import PlanSummaryHeader from '../../../../components/Billing/PlanSummaryHeader';
import UsageBar from '../../../../components/Billing/UsageBar';
import AddOnsSection from './sections/AddOnsSection';
import BillingStatusNotice from './sections/BillingStatusNotice';
import PlanActions from './sections/PlanActions';

function Billing(props) {
    const {
        publisher,
    } = props;

    const classes = useStyles();

    const {
        publisherPlan,
        isUpgrading,
        planName,
        hasCurrentPlan,
        currencySymbol,
        total,
        remaining,
        used,
        usedPercent,
        showUsageBar,
        isUnlimitedSubscribers,
        showBilling,
        showAddOns,
        showBillingAlt,
        showAwsBillingInfo,
        isFreeOrTrialPlan,
        supportLabel,
        handleUpgradeClick,
    } = useEcalPlanState({ publisher });

    const {
        openDialog,
        renderUpgradePlanDialog,
    } = useUpgradePlanDialog();

    const {
        openDialog: openAddonUpgrade,
        renderDialog: renderAddonUpgrade,
    } = useAddOnsDialog();

    const tierLabel = isUnlimitedSubscribers
        ? 'Unlimited subscribers'
        : (total > 0 ? `${total.toLocaleString()} subscribers` : '');

    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Grid item justify={'center'} container>
                        <Box
                            display={'flex'}
                            flexDirection={'column'}
                            width={'100%'}
                        >
                            <Box className={classes.card}>
                                <PlanSummaryHeader
                                    microLabel="ECAL Plan"
                                    planName={planName}
                                    showActiveBadge={hasCurrentPlan}
                                    tierLabel={tierLabel}
                                    price={publisherPlan?.price}
                                    currencySymbol={currencySymbol}
                                />

                                {showUsageBar && (
                                    <UsageBar
                                        used={used}
                                        total={total}
                                        remaining={remaining}
                                        usedPercent={usedPercent}
                                    />
                                )}

                                {showAddOns && (
                                    <AddOnsSection addOns={publisherPlan?.addOns} />
                                )}

                                <BillingStatusNotice
                                    showBilling={showBilling}
                                    showAwsBillingInfo={showAwsBillingInfo}
                                    showBillingAlt={showBillingAlt}
                                    isFreeOrTrialPlan={isFreeOrTrialPlan}
                                    supportLabel={supportLabel}
                                    onContactClick={handleUpgradeClick}
                                />

                                {showBilling && (
                                    <PlanActions
                                        isFreeOrTrialPlan={isFreeOrTrialPlan}
                                        isUpgrading={isUpgrading}
                                        onAddExtraServices={() => openAddonUpgrade()}
                                        onUpgradePlan={() => openDialog()}
                                    />
                                )}
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            {renderUpgradePlanDialog()}
            {renderAddonUpgrade()}
        </React.Fragment>
    );
}

Billing.propTypes = {
    publisher: PropTypes.object,
};

const ObservedBilling = observer(Billing);
export default ObservedBilling;
